module.exports = new __parcel__URL__("automation-icon-legacy.b90e5d5a.svg").toString();